import Fuse from "fuse.js";

// eslint-disable-next-line no-shadow
export enum LLMSummaryStatus {
  QUEUED = 0,
  PROCESSING = 1,
  DONE = 2,
  ERROR = 3,
  NOT_FOUND = 4
}

export type LLMTextLink = {
  text_idx: number;
  start: number;
  end: number;
  type: string;
  value: string;
};

export type LLMSection = {
  text?: string[];
  title?: string;
  links?: LLMTextLink[];
};

export type LLMThinkingStep = {
  sections: string[];
  text: string;
};

export type LLMSummary = {
  status: LLMSummaryStatus;
  summary?: {
    summary?: {
      classification?: LLMSection | null;
      executive_summary?: LLMSection | null;
      file_behavior?: LLMSection | null;
      file_info?: LLMSection | null;
      network_references?: LLMSection | null;
      relationships?: LLMSection | null;
    };
    thinking_steps?: LLMThinkingStep[];
  };
};

export type LLMSummaryHasChanged = {
  has_changed: boolean;
};

export type IocRow = {
  name: string;
  type: string;
};

export type LinkSearchRules = {
  keyword: string;
  url: string;
  adjacentMatch: Fuse<string>;
};
